module.exports = __webpack_public_path__ + "img/persona4.55d2837b.png";